module.exports = __webpack_public_path__ + "static/banner-1-e7f97cc1466abe110d513229d7613929.png";